const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  userId: state => state.user.userId,
  organId: state => state.user.organId || '123456',
  role: state => state.user.role || ''

}
export default getters
